import React from 'react';
import { Button } from './ui/button';

export default function MobileHeader({ title, onMenuClick }) {
  return (
    <div style={{
      display: 'none',
      alignItems: 'center', gap: '12px',
      padding: '12px 0', marginBottom: '12px',
      borderBottom: '1px solid hsl(140 18% 86%)'
    }} className="mobile-header">
      <button
        onClick={onMenuClick}
        style={{
          background: 'none', border: 'none', cursor: 'pointer',
          padding: '8px', borderRadius: '6px', color: '#1a5c2e'
        }}
      >
        ☰
      </button>
      <span style={{ fontFamily: 'Space Grotesk', fontWeight: 600, color: '#1a5c2e', fontSize: '16px' }}>{title}</span>
      <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#3aaa62' }}></div>
        <span style={{ fontSize: '12px', color: '#888' }}>Valoriza IT</span>
      </div>
    </div>
  );
}

// Expose so it can be shown on mobile
const style = document.createElement('style');
style.textContent = `
  @media (max-width: 768px) {
    .mobile-header { display: flex !important; }
  }
`;
document.head.appendChild(style);
